import { Duration } from "luxon";
import { toDateTime } from "./toDateTime";
const TIME_UNITS = ["years", "months", "weeks", "days", "hours", "minutes", "seconds"];
export const dateTimeDurationToHuman = (duration, options) => {
    var _a, _b, _c, _d;
    const durationObj = duration.shiftTo(...TIME_UNITS).toObject();
    const nonZeroUnits = [];
    for (const unit of TIME_UNITS) {
        const value = durationObj[unit];
        if (value && Math.abs(value) > 0) {
            nonZeroUnits.push({ unit, value });
            break;
        }
    }
    if (nonZeroUnits.length === 0) {
        console.warn("durationToHuman", durationObj, "Не удалось преобразовать время в текст");
        return (_a = options === null || options === void 0 ? void 0 : options.defaultValue) !== null && _a !== void 0 ? _a : "-";
    }
    const unit = nonZeroUnits[0];
    const isNegative = unit.value < 0;
    const absoluteValue = Math.abs(unit.value);
    const humanText = Duration.fromObject({
        [unit.unit]: absoluteValue
    }).toHuman((_b = options === null || options === void 0 ? void 0 : options.formatOptions) !== null && _b !== void 0 ? _b : { unitDisplay: "long" });
    const defaultText = isNegative ? `через ${humanText}` : `${humanText} назад`;
    return (_d = (_c = options === null || options === void 0 ? void 0 : options.return) === null || _c === void 0 ? void 0 : _c.call(options, { defaultText, humanText, durationObj, nonZeroUnits })) !== null && _d !== void 0 ? _d : defaultText;
};
export const dateTimeDiffToHuman = (startDate, endDate, options) => {
    try {
        const start = toDateTime(startDate);
        const end = toDateTime(endDate);
        if (start.isValid && end.isValid) {
            const diff = end.diff(start, [...TIME_UNITS]);
            return dateTimeDurationToHuman(diff, options);
        }
        return undefined;
    }
    catch (_a) {
        return undefined;
    }
};
